<template>
  <v-container fluid class="theme-color fill-height">
    <OverviewDashboard class="dialog" :class="{ xs: $vuetify.breakpoint.xsOnly }" />
  </v-container>
</template>

<script>
import OverviewDashboard from '../components/main-dashboard/OverviewDashboard';

export default {
  name: 'MainDashboard',
  components: { OverviewDashboard },
  data: () => ({
    condition: null
  }),
  mounted() {
    this.$emit('sethambergervisible', true);
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
